import React from "react"
import { AppProps } from "next/app"

import "../styles/style.scss"
import "../styles/misc/checkbox.scss"

import "react-multi-carousel/lib/styles.css"
import { ComponentProvider } from "@lib/context/ComponentContext"

function App({ Component, pageProps }: AppProps) {
  return (
    <ComponentProvider>
      <Component {...pageProps} />
    </ComponentProvider>
  )
}

export default App
